export default {
  'delegations.title': 'Gestionar Delegaciones',

  'delegations.form.id': 'ID',
  'delegations.form.status': 'Estado',
  'delegations.form.type': 'Tipo',
  'delegations.form.delegationNumber': 'Nro Delegación',
  'delegations.form.startDate': 'Inicio',
  'delegations.form.endDate': 'Fin',
  'delegations.form.approver': 'Usuario Aprobador',
  'delegations.form.reason': 'Motivo',
  'delegations.form.delegatePendingTasks': '¿Delegar Tareas Pendientes?',
  'delegations.form.keepSourceUserAsApproval': '¿Mantener Usuario Aprobador?',
  'delegations.form.removeDelegatedTasksAtTheEnd':
    '¿Remover Tareas Delegadas al Finalizar Delegación?',

  'delegations.delegationType.temporary': 'Temporal',
  'delegations.delegationType.definitive': 'Definitiva',

  'delegations.delegationStatus.pending': 'Pendiente',
  'delegations.delegationStatus.execution': 'En ejecución',
  'delegations.delegationStatus.finished': 'Finalizado',
  'delegations.delegationStatus.voided': 'Anulado',
  'delegations.delegationStatus.error': 'Error',
  'delegations.delegationStatus.modal.cancel.title': 'Motivo de Anulación',
  'delegations.delegatedTasks': 'Tareas Delegadas',
};
